class WCSaveButton extends HTMLElement {
  constructor() {
    super();
    Object.assign(this, {
      button: null,
      accessibleLabels: {},
      state: {
        productId: null,
        variantId: null
      }
    });
  }

  connectedCallback() {
    this.button = this.querySelector('.status-favorite-button')
    if (!this.button) { return}

    this.accessibleLabels = {
      active: (title) => `Remove ${title} from favorites`,
      inactive: (title) => `Add ${title} to favorites`
    }

    this.state.variantId = this.getVariantId()
    this.state.productId =+ this.button?.dataset.productId

    if (window.StatusAccounts?.customer) {
      this.init({ watcher: true })?.bind(this)
    } else {
      document.addEventListener('status:loaded', (e) => {
        this.init({ watcher: true })?.bind(this)
      });
    }
  }

  setButtonState(favorites = StatusAccounts.wishlist) {
    const productTitle = this.button?.dataset.productTitle
    const isActive = favorites?.includes(this.state.productId)
    const status = isActive ? 'active' : 'inactive'

    this.button?.setAttribute('aria-pressed', String(isActive))
    this.button?.setAttribute('aria-label', this.accessibleLabels[status](productTitle))
  }

  getVariantId() {
    let urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('variant') ? +urlParams.get('variant') : +this.button?.dataset.variantId
  }

  initEvents() {
    this.button.addEventListener('click', () => {
      this.state.variantId = this.getVariantId()
      const isActive = this.button?.getAttribute('aria-pressed') === 'true'

      this.setButtonState(isActive ? [] : [this.state.productId])

      const browserEvent = new CustomEvent(isActive ? 'status:item:remove' : 'status:item:save',
        {
        detail: {
          productId: this.state.productId,
          variantId : this.state.variantId,
          triggerToast: true,
        }
      })

      document.dispatchEvent(browserEvent)

    })
    document.addEventListener('status:items:updated', (event) => {
      this.setButtonState(event.detail.items)
    })
  }

  init() {
    this.initEvents()
    this.setButtonState(window.StatusAccounts.wishlist)
  }
}

if (!customElements.get('wc-save-button')) {
  customElements.define('wc-save-button', WCSaveButton);
}
